import CampusHeader from '../../components/feature/CampusHeader';
import Footer from '../../components/feature/Footer';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <CampusHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">Terms of Service</h1>
        <p className="text-gray-700 mb-8">
          By using our marketplace, you agree to these terms.
        </p>

        <section className="space-y-4 mb-10">
          <h2 className="text-2xl font-semibold text-gray-900">Use of Service</h2>
          <p className="text-gray-700">
            You must comply with applicable laws and avoid prohibited content and conduct.
          </p>
        </section>

        <section className="space-y-4 mb-10">
          <h2 className="text-2xl font-semibold text-gray-900">Listings and Transactions</h2>
          <p className="text-gray-700">
            Provide accurate information, set fair prices, and follow campus-specific policies.
          </p>
        </section>

        <section className="space-y-4 mb-10">
          <h2 className="text-2xl font-semibold text-gray-900">Billing and Fees</h2>
          <p className="text-gray-700">
            Campket does not take a percentage cut from sales. Sellers can list for free on the Basic plan or choose a Premium subscription (monthly, quarterly, or yearly) that unlocks unlimited features, product ranking, and a verification badge. Optional sponsored promotions (daily, weekly, 2-week campus-wide, and buyer mail recommendations) are available for extra visibility.
          </p>
        </section>

        <section className="space-y-4 mb-10">
          <h2 className="text-2xl font-semibold text-gray-900">Payments & Refunds</h2>
          <p className="text-gray-700">
            Payment terms are defined by your chosen method; refunds follow our support policies.
          </p>
        </section>

        <section className="space-y-4 mb-10">
          <h2 className="text-2xl font-semibold text-gray-900">Disputes</h2>
          <p className="text-gray-700">
            Disputes may be resolved via mediation or applicable legal processes.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-900">Contact</h2>
          <p className="text-gray-700">
            For legal inquiries, contact <a href="mailto:hello@synccore.com" className="text-blue-600 hover:underline">hello@synccore.com</a>.
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default TermsPage;